var metric, imperial;

/**
 * Base anchor unit:
 *   Metric  → m/s²
 *   Imperial → ft/s²
 */

metric = {
  "m/s²": {
    name: {
      singular: "Metre per second squared",
      plural: "Metres per second squared",
    },
    to_anchor: 1,
  },

  "cm/s²": {
    name: {
      singular: "Centimetre per second squared",
      plural: "Centimetres per second squared",
    },
    to_anchor: 0.01,
  },

  "mm/s²": {
    name: {
      singular: "Millimetre per second squared",
      plural: "Millimetres per second squared",
    },
    to_anchor: 0.001,
  },

  g: {
    name: {
      singular: "Standard gravity",
      plural: "Standard gravities",
    },
    to_anchor: 9.80665, // 1 g = 9.80665 m/s²
  },

  gal: {
    name: {
      singular: "Gal",
      plural: "Gals",
    },
    to_anchor: 0.01, // 1 Gal = 1 cm/s²
  },
};

imperial = {
  "ft/s²": {
    name: {
      singular: "Foot per second squared",
      plural: "Feet per second squared",
    },
    to_anchor: 1,
  },

  "in/s²": {
    name: {
      singular: "Inch per second squared",
      plural: "Inches per second squared",
    },
    to_anchor: 1 / 12, // 12 inches = 1 foot
  },

  "yd/s²": {
    name: {
      singular: "Yard per second squared",
      plural: "Yards per second squared",
    },
    to_anchor: 3, // 1 yard = 3 feet
  },

  "mi/s²": {
    name: {
      singular: "Mile per second squared",
      plural: "Miles per second squared",
    },
    to_anchor: 5280, // 1 mile = 5280 feet
  },
};

module.exports = {
  metric,
  imperial,
  _anchors: {
    metric: {
      unit: "m/s²",
      ratio: 1 / 3.28084, // m ↔ ft
    },
    imperial: {
      unit: "ft/s²",
      ratio: 3.28084,
    },
  },
};
